// @generated
// This file was automatically generated and should not be edited.

import loadable from '@loadable/component';
import { SectionProps } from './types';

const sectionsComponentsMap = {
  aboutUsSection: loadable(
    () => import('./templates/AboutUsSection/index')
  ) as unknown as React.FC<SectionProps>,
  activityBookingSection: loadable(
    () => import('./templates/ActivityBookingSection/index')
  ) as unknown as React.FC<SectionProps>,
  bookNowSection: loadable(
    () => import('./templates/BookNowSection/index')
  ) as unknown as React.FC<SectionProps>,
  heroBaseSection: loadable(
    () => import('./templates/HeroBaseSection/index')
  ) as unknown as React.FC<SectionProps>,
  heroWithContactFormSection: loadable(
    () => import('./templates/HeroWithContactFormSection/index')
  ) as unknown as React.FC<SectionProps>,
  heroWithPostsSection: loadable(
    () => import('./templates/HeroWithPostsSection/index')
  ) as unknown as React.FC<SectionProps>,
  heroWithTabsSection: loadable(
    () => import('./templates/HeroWithTabsSection/index')
  ) as unknown as React.FC<SectionProps>,
  hotelsSection: loadable(
    () => import('./templates/HotelsSection/index')
  ) as unknown as React.FC<SectionProps>,
  hotelsTabsSection: loadable(
    () => import('./templates/HotelsTabsSection/index')
  ) as unknown as React.FC<SectionProps>,
  hotelWithFeaturesListSection: loadable(
    () => import('./templates/HotelWithFeaturesListSection/index')
  ) as unknown as React.FC<SectionProps>,
  imagesGallerySection: loadable(
    () => import('./templates/ImagesGallerySection/index')
  ) as unknown as React.FC<SectionProps>,
  locationSection: loadable(
    () => import('./templates/LocationSection/index')
  ) as unknown as React.FC<SectionProps>,
  postTeasersSection: loadable(
    () => import('./templates/PostTeasersSection/index')
  ) as unknown as React.FC<SectionProps>,
  powerConsumptionSection: loadable(
    () => import('./templates/PowerConsumptionSection/index')
  ) as unknown as React.FC<SectionProps>,
  reviewsCarouselSection: loadable(
    () => import('./templates/ReviewsCarouselSection/index')
  ) as unknown as React.FC<SectionProps>,
  socialIconsSection: loadable(
    () => import('./templates/SocialIconsSection/index')
  ) as unknown as React.FC<SectionProps>,
  stepByStepSection: loadable(
    () => import('./templates/StepByStepSection/index')
  ) as unknown as React.FC<SectionProps>,
  teamSection: loadable(
    () => import('./templates/TeamSection/index')
  ) as unknown as React.FC<SectionProps>,
  textListSection: loadable(
    () => import('./templates/TextListSection/index')
  ) as unknown as React.FC<SectionProps>,
  textSection: loadable(
    () => import('./templates/TextSection/index')
  ) as unknown as React.FC<SectionProps>,
  tilesSection: loadable(
    () => import('./templates/TilesSection/index')
  ) as unknown as React.FC<SectionProps>,
  titleFaqSection: loadable(
    () => import('./templates/TitleFaqSection/index')
  ) as unknown as React.FC<SectionProps>,
  transportOptionsSection: loadable(
    () => import('./templates/TransportOptionsSection/index')
  ) as unknown as React.FC<SectionProps>,
  transportScheduleSection: loadable(
    () => import('./templates/TransportScheduleSection/index')
  ) as unknown as React.FC<SectionProps>,
  videoBoxSection: loadable(
    () => import('./templates/VideoBoxSection/index')
  ) as unknown as React.FC<SectionProps>,
  wideBannerSection: loadable(
    () => import('./templates/WideBannerSection/index')
  ) as unknown as React.FC<SectionProps>,
};

export default sectionsComponentsMap;
